export default __webpack_public_path__ + "static/IN-9008HD-vs-IN-5905HD_day-22c12bdd761dd17c50738616e0d493cf.webp";